import React, { useEffect } from "react";
import { Container } from "../../../components";
import { Heading, Icon, Text } from "@telia/teddy";
import { useSelector } from "react-redux";
import { FWA_LABELS } from "../../../../../constants";
import { RootState } from "../../../../../models";
import { trackFunnelEvent } from "../../../google-analytics";
import SummaryTable from "../../components/organisms/SummaryTable/SummaryTable";
import * as FWA_SELECTORS from "../../state/selectors";
import TEXT from "../../text-consts";
import "./Receipt.less";

const Receipt = () => {
    const selectedPackageId = useSelector((state: RootState) => FWA_SELECTORS.getSelectedPackageId(state));
    const isSelectedPackageDIY = useSelector((state: RootState) => FWA_SELECTORS.isSelectedPackageDIY(state));

    const {
        monthlyItems,
        upfrontItems,
        totalMonthlyBBPrice,
        totalMonthlyBBDiscountedPrice,
        totalUpfrontBBPrice,
        totalUpfrontBBDiscountedPrice,
    } = useSelector((state: RootState) => FWA_SELECTORS.getProductsForSelectedPackageId(state, selectedPackageId));
    const cartPackage = useSelector((state: RootState) =>
        FWA_SELECTORS.getSelectedPackageDisclaimerText(state, FWA_SELECTORS.getSelectedPackageId(state)),
    );

    // Trigger GA funnel
    useEffect(() => {
        trackFunnelEvent({ step: "4", label: FWA_LABELS[3], name: "FWA - Trådløst Bredbånd" });
    }, []);

    return (
        <Container className="fwa-receipt" size="small">
            <Heading mb="100" as="h1" variant="title-600" className="fwa-receipt__header">
                {TEXT.RECEIPT.HEADING}
                <Icon name="like" />
            </Heading>
            <div className="fwa-receipt__orderconfirmation">
                <Text mb="100">{TEXT.RECEIPT.ORDER.ORDERCONFIRMATION}</Text>
            </div>
            <div className="fwa-receipt__installation">
                {/* TODO: ADD ICON IN SG */}
                <Heading mb="100" as="h2" variant="title-200">
                    {TEXT.RECEIPT.INSTALLATION.HEADING}
                </Heading>
                <p
                    className="paragraph"
                    dangerouslySetInnerHTML={{
                        __html: isSelectedPackageDIY
                            ? TEXT.RECEIPT.INSTALLATION.PARAGRAPH_DIY
                            : TEXT.RECEIPT.INSTALLATION.PARAGRAPH,
                    }}
                />
            </div>
            <div>
                <Heading mb="100" as="h2" variant="title-200" className="fwa-personal-details__summary-heading">
                    {TEXT.PERSONAL_DETAILS.HEADING_RECEIPT}
                </Heading>
                <SummaryTable
                    items={monthlyItems}
                    upfrontItems={upfrontItems}
                    totalUpfrontPrice={totalUpfrontBBPrice}
                    totalUpfrontDiscountedPrice={totalUpfrontBBDiscountedPrice}
                    totalPrice={totalMonthlyBBPrice}
                    totalDiscountedPrice={totalMonthlyBBDiscountedPrice}
                />
                {cartPackage && <p className="paragraph fwa-summary__disclaimer">{TEXT.SUMMARY.DISCLAIMER}</p>}
            </div>
        </Container>
    );
};

export default Receipt;
